import { Reveal, MaskedTitle } from "@/components/Motion";

// Socle commun des sections V3 « programme de gala » :
// fond sombre uni (coupures nettes), texte clair, aucun en-tête standardisé.
export const V3Section = ({ id, bg = "#0B0A0A", className = "", children, testid, grain = false }) => (
  <section
    id={id}
    data-testid={testid || (id ? `section-${id}` : undefined)}
    className={`relative text-white ${grain ? "grain" : ""} ${className}`}
    style={{ background: bg }}
  >
    <div className="mx-auto w-full max-w-[1200px] px-6 md:px-12 lg:px-16">{children}</div>
  </section>
);

export const V3Eyebrow = ({ children, className = "" }) => (
  <Reveal>
    <p className={`flex items-center gap-4 text-[0.75rem] uppercase tracking-[0.35em] text-copper ${className}`}>
      <span className="h-px w-10 bg-current" aria-hidden="true" />
      {children}
    </p>
  </Reveal>
);

export const V3Title = ({ children, className = "", testid }) => (
  <MaskedTitle
    className={`mt-6 font-serif text-[1.7rem] leading-[1.15] tracking-tight text-white md:text-[2.4rem] ${className}`}
    data-testid={testid}
  >
    {children}
  </MaskedTitle>
);
